import * as React from 'react'
import { LicenseItem } from './LicenseItem'
import { Styled } from './LicenseList.styled'
import { License } from './types'

export const LicensesList = ({ licenses, loading }: { licenses: License[] | undefined; loading: boolean }) => {
  if (!licenses || loading) {
    return null
  }

  return (
    <div>
      <Styled.Title>Evaluation license key</Styled.Title>
      <Styled.List>
        {licenses.map(license => (
          <LicenseItem license={license} key={license.id} />
        ))}
      </Styled.List>
    </div>
  )
}
